export const SET_CONSUMABLES = 'SET_CONSUMABLES';
export const POST_UPDATE_CONSUMABLE_START = 'POST_UPDATE_CONSUMABLE_START';
export const POST_UPDATE_CONSUMABLE_END = 'POST_UPDATE_CONSUMABLE_END';
export const POST_UPDATE_CONSUMABLE_ERROR = 'POST_UPDATE_CONSUMABLE_ERROR';
export default SET_CONSUMABLES;
